module.exports = __webpack_public_path__ + "static/media/Escenografias-para-eventos- 2.7466dc59.JPG";